interface EnvironmentConfig {
	ALLOWED_ORIGINS: string;
	PUBLIC_BASE_URL?: string;
}

declare global {
	interface Window {
		_env_?: EnvironmentConfig;
	}
}

const DEFAULT_CONFIG: EnvironmentConfig = {
	ALLOWED_ORIGINS: '',
	PUBLIC_BASE_URL: '',
};

const getEnvValue = (
	key: keyof EnvironmentConfig,
	defaultValue = '',
): string => {
	if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
		const value = window._env_[key];
		if (typeof value === 'string' && !value.includes('%')) {
			return value;
		}
	}

	try {
		const envValue = (
			globalThis as typeof globalThis & {
				process?: { env?: Record<string, string> };
			}
		).process?.env?.[key];
		return envValue || defaultValue;
	} catch {
		return defaultValue;
	}
};

export const getEnvConfig = (): EnvironmentConfig => ({
	ALLOWED_ORIGINS: getEnvValue(
		'ALLOWED_ORIGINS',
		DEFAULT_CONFIG.ALLOWED_ORIGINS,
	),
	PUBLIC_BASE_URL: getEnvValue(
		'PUBLIC_BASE_URL',
		DEFAULT_CONFIG.PUBLIC_BASE_URL,
	),
});

export const getAllowedOrigins = (): string => getEnvConfig().ALLOWED_ORIGINS;

export const getIframeAllowedOrigins = (): string[] => {
	let allowedOrigins = getAllowedOrigins();
	if (!allowedOrigins) {
		allowedOrigins = process.env.ALLOWED_ORIGINS || '';
	}
	return allowedOrigins ? allowedOrigins.split(',') : ['http://localhost:3000'];
};
